import React from 'react';
import { Link } from 'react-router-dom';

function PrivacyPolicy() {
  return (
    <div className="min-h-safe-screen bg-[#fff]">
      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 py-8 pb-24">
        <h1 className="text-[var(--Color-Grays-Gray-10,#0D0C07)] text-[28px] font-bold leading-[36px] mb-2">
          Política de Privacidad
        </h1>
        <p className="text-[#878683] text-[14px] mb-8">
          Última actualización: 12 de abril de 2026
        </p>

        <div className="prose prose-gray max-w-none">

          {/* ── 1. Responsable del tratamiento ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">1. Responsable del Tratamiento</h2>
          <p className="text-[16px] leading-[28px] mb-4">
            El responsable del tratamiento de tus datos personales es:
          </p>
          <ul className="list-none pl-0 mb-6 space-y-1">
            <li className="text-[16px] leading-[28px]"><strong>Razón social:</strong> Good UX OÜ</li>
            <li className="text-[16px] leading-[28px]"><strong>Número de registro:</strong> 16529659 (Registro Mercantil de Estonia)</li>
            <li className="text-[16px] leading-[28px]"><strong>Correo electrónico:</strong> <a href="mailto:privacy@9meals.ai" className="text-[#006600] underline">privacy@9meals.ai</a></li>
          </ul>
          <p className="text-[16px] leading-[28px] mb-6">
            Good UX OÜ es una sociedad constituida en Estonia, Estado miembro del Espacio Económico Europeo (EEE), y está sujeta directamente al Reglamento General de Protección de Datos (RGPD — Reglamento (UE) 2016/679). Al ofrecer nuestros servicios a usuarios en España, cumplimos también con la Ley Orgánica 3/2018 de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD) y la Ley 34/2002, de servicios de la sociedad de la información y de comercio electrónico (LSSI-CE).
          </p>

          {/* ── 2. Principios ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">2. Principios de Privacidad</h2>
          <p className="text-[16px] leading-[28px] mb-6">
            La información sobre tus planes de comidas, dieta y preferencias alimentarias es privada. Entendemos la responsabilidad de proteger la privacidad y seguridad de esta información y haremos todo lo posible por mantenerla segura. Recopilamos información sobre tu uso de 9meals.ai para mejorar la aplicación. Esta política no pretende poner límites a lo que hacemos con datos de uso que están agregados o desidentificados de manera que ya no estén vinculados a un usuario de 9meals.ai.
          </p>

          {/* ── 3. Información que recopilamos ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">3. Información que Recopilamos</h2>
          <p className="text-[16px] leading-[28px] mb-4">
            Recopilamos las siguientes categorías de datos personales:
          </p>
          <ul className="list-disc pl-6 mb-6 space-y-3">
            <li className="text-[16px] leading-[28px]">
              <strong>Datos de cuenta.</strong> Cuando te registras en 9meals.ai, recopilamos tu dirección de correo electrónico y, opcionalmente, tu nombre. Si te registras mediante Google, recibimos tu nombre y correo electrónico de tu proveedor de identidad.
            </li>
            <li className="text-[16px] leading-[28px]">
              <strong>Preferencias alimentarias.</strong> Cuando accedes y comienzas a usar 9meals.ai, te hacemos preguntas sobre tus hábitos y preferencias alimentarias: número de personas, presupuesto, preferencias dietéticas (vegetariano, vegano, sin gluten, etc.), alergias, estilo de cocina y tiempo de preparación. Estos datos se almacenan de forma local en tu navegador y, si te registras, también en nuestros servidores.
            </li>
            <li className="text-[16px] leading-[28px]">
              <strong>Contenido generado.</strong> Los planes de comidas, listas de la compra, recetas guardadas y el estado de productos marcados como «ya lo tengo».
            </li>
            <li className="text-[16px] leading-[28px]">
              <strong>Datos del dispositivo y técnicos.</strong> Tipo de dispositivo, sistema operativo, navegador, idioma, resolución de pantalla, identificadores de dispositivo generados aleatoriamente y datos de fallos.
            </li>
            <li className="text-[16px] leading-[28px]">
              <strong>Dirección IP y ubicación aproximada.</strong> Utilizamos tu dirección IP para determinar tu país mediante el servicio ipwho.is, con el fin de mostrar productos y precios locales. No almacenamos tu dirección IP de forma permanente.
            </li>
            <li className="text-[16px] leading-[28px]">
              <strong>Datos de uso y analítica.</strong> Recopilamos datos sobre las acciones que realizas dentro de 9meals.ai (páginas visitadas, funcionalidades utilizadas, errores encontrados) a través de herramientas de analítica. Con tu consentimiento, una muestra del 10 % de las sesiones puede incluir grabación de pantalla anonimizada (con campos sensibles enmascarados) para identificar problemas de usabilidad.
            </li>
            <li className="text-[16px] leading-[28px]">
              <strong>Datos de pago.</strong> Si contratas una suscripción Premium, el procesamiento del pago lo realiza Stripe, Inc. No almacenamos números de tarjeta ni datos bancarios en nuestros servidores — únicamente el identificador de cliente de Stripe y el estado de tu suscripción.
            </li>
          </ul>

          {/* ── 4. Uso de inteligencia artificial ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">4. Uso de Inteligencia Artificial</h2>
          <p className="text-[16px] leading-[28px] mb-4">
            9meals.ai utiliza sistemas de inteligencia artificial (IA) de terceros para generar contenido personalizado. En cumplimiento con el Reglamento (UE) 2024/1689 (Ley de IA de la UE), te informamos de lo siguiente:
          </p>
          <ul className="list-disc pl-6 mb-6 space-y-3">
            <li className="text-[16px] leading-[28px]">
              <strong>Generación de planes de comidas</strong> — Se utilizan modelos de Anthropic (Claude) para crear planes de comidas personalizados basados en tus preferencias.
            </li>
            <li className="text-[16px] leading-[28px]">
              <strong>Detalles de recetas</strong> — Se utilizan modelos de OpenAI (GPT) para generar instrucciones de cocina detalladas, pasos de preparación e información de almacenamiento.
            </li>
            <li className="text-[16px] leading-[28px]">
              <strong>Listas de la compra</strong> — Se utilizan modelos de Google (Gemini) para consolidar ingredientes y generar listas de compra optimizadas.
            </li>
            <li className="text-[16px] leading-[28px]">
              <strong>Imágenes de recetas</strong> — Se utilizan servicios de generación de imágenes (Runware, ModelsLab) para crear fotografías ilustrativas de los platos.
            </li>
          </ul>
          <p className="text-[16px] leading-[28px] mb-4">
            <strong>Datos enviados a proveedores de IA:</strong> Las solicitudes enviadas a estos servicios contienen tus preferencias alimentarias (tipo de dieta, alergias, número de personas, tiempo de cocina) y los ingredientes de las recetas. <strong>No se envían</strong> tu nombre, correo electrónico, dirección IP ni otros datos directamente identificativos.
          </p>
          <p className="text-[16px] leading-[28px] mb-4">
            Todas las llamadas a servicios de IA se realizan a través de nuestro servidor backend (proxy). Las claves de API nunca se exponen al navegador del usuario.
          </p>
          <p className="text-[16px] leading-[28px] mb-6">
            <strong>Aviso importante:</strong> El contenido generado por IA (planes de comidas, recetas, imágenes) es orientativo y no constituye asesoramiento médico, nutricional ni dietético profesional. Consulta siempre a un profesional de la salud antes de realizar cambios significativos en tu dieta, especialmente si padeces alergias alimentarias, intolerancias o condiciones médicas.
          </p>

          {/* ── 5. Decisiones automatizadas ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">5. Decisiones Automatizadas</h2>
          <p className="text-[16px] leading-[28px] mb-6">
            De conformidad con el artículo 22 del RGPD, te informamos de que 9meals.ai genera planes de comidas y recomendaciones de recetas de forma automatizada, basándose en las preferencias que proporcionas (dieta, presupuesto, número de personas, estilo de cocina). Estas recomendaciones <strong>no producen efectos jurídicos</strong> ni te afectan significativamente de forma similar. Además, mantienes el control total: puedes rechazar cualquier receta sugerida, solicitar alternativas, modificar tus preferencias en cualquier momento o generar un plan completamente nuevo.
          </p>

          {/* ── 6. Cómo usamos la información ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">6. Cómo Usamos tu Información</h2>
          <ul className="list-disc pl-6 mb-6 space-y-3">
            <li className="text-[16px] leading-[28px]">
              <strong>Proporcionar el servicio.</strong> Usar tus preferencias para generar planes de comidas personalizados, recetas, imágenes y listas de la compra adaptados a tu localización.
            </li>
            <li className="text-[16px] leading-[28px]">
              <strong>Gestionar tu cuenta y suscripción.</strong> Autenticarte, gestionar tu suscripción Premium y procesar pagos a través de Stripe.
            </li>
            <li className="text-[16px] leading-[28px]">
              <strong>Comunicaciones transaccionales.</strong> Enviarte correos electrónicos necesarios para el funcionamiento del servicio: códigos de acceso (OTP), confirmaciones de pago y avisos de cambios importantes en el servicio.
            </li>
            <li className="text-[16px] leading-[28px]">
              <strong>Comunicaciones comerciales.</strong> Con tu consentimiento previo y explícito, enviarte correos electrónicos con ofertas, novedades y contenido promocional. Puedes retirar tu consentimiento en cualquier momento mediante el enlace de baja incluido en cada correo o contactándonos en <a href="mailto:privacy@9meals.ai" className="text-[#006600] underline">privacy@9meals.ai</a>.
            </li>
            <li className="text-[16px] leading-[28px]">
              <strong>Mejorar el producto.</strong> Analizar datos de uso agregados para comprender cómo se utiliza la aplicación y mejorar la experiencia de usuario.
            </li>
            <li className="text-[16px] leading-[28px]">
              <strong>Soporte.</strong> Responder a tus consultas y resolver incidencias.
            </li>
          </ul>

          {/* ── 7. Base legal ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">7. Base Legal para el Tratamiento</h2>
          <p className="text-[16px] leading-[28px] mb-4">
            Conforme al artículo 6 del RGPD, procesamos tus datos personales bajo las siguientes bases legales:
          </p>
          <div className="overflow-x-auto mb-6">
            <table className="w-full text-[14px] leading-[24px] border-collapse">
              <thead>
                <tr className="border-b border-gray-200">
                  <th className="text-left py-3 pr-4 font-bold">Finalidad</th>
                  <th className="text-left py-3 pr-4 font-bold">Base legal (RGPD Art. 6)</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-100">
                  <td className="py-3 pr-4">Prestación del servicio (generación de planes, recetas, listas de la compra)</td>
                  <td className="py-3 pr-4">Ejecución del contrato — Art. 6.1.b)</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-3 pr-4">Gestión de cuenta y suscripción Premium</td>
                  <td className="py-3 pr-4">Ejecución del contrato — Art. 6.1.b)</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-3 pr-4">Comunicaciones transaccionales (OTP, confirmaciones)</td>
                  <td className="py-3 pr-4">Ejecución del contrato — Art. 6.1.b)</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-3 pr-4">Comunicaciones comerciales (ofertas, novedades)</td>
                  <td className="py-3 pr-4">Consentimiento — Art. 6.1.a)</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-3 pr-4">Analítica y mejora del producto</td>
                  <td className="py-3 pr-4">Interés legítimo — Art. 6.1.f)</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-3 pr-4">Cookies de analítica y grabación de sesiones</td>
                  <td className="py-3 pr-4">Consentimiento — Art. 6.1.a) + LSSI-CE Art. 22.2</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-3 pr-4">Conservación de datos fiscales y de pago</td>
                  <td className="py-3 pr-4">Obligación legal — Art. 6.1.c)</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* ── 8. Cookies ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">8. Cookies y Almacenamiento Local</h2>
          <p className="text-[16px] leading-[28px] mb-4">
            9meals.ai utiliza cookies y tecnologías de almacenamiento local del navegador (localStorage, sessionStorage). Para información detallada sobre las cookies que utilizamos, sus finalidades y cómo gestionarlas, consulta nuestra <Link to="/cookies" className="text-[#006600] underline">Política de Cookies</Link>.
          </p>
          <p className="text-[16px] leading-[28px] mb-6">
            Las cookies de analítica y las funciones de grabación de sesiones solo se activan tras obtener tu consentimiento explícito a través de nuestro banner de cookies.
          </p>

          {/* ── 9. Proveedores terceros ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">9. Proveedores de Servicios Terceros</h2>
          <p className="text-[16px] leading-[28px] mb-4">
            Para prestar el servicio, compartimos datos con los siguientes proveedores que actúan como encargados del tratamiento bajo nuestras instrucciones:
          </p>
          <div className="overflow-x-auto mb-6">
            <table className="w-full text-[14px] leading-[24px] border-collapse">
              <thead>
                <tr className="border-b border-gray-200">
                  <th className="text-left py-3 pr-4 font-bold">Proveedor</th>
                  <th className="text-left py-3 pr-4 font-bold">Función</th>
                  <th className="text-left py-3 pr-4 font-bold">Ubicación</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-100">
                  <td className="py-3 pr-4">Microsoft Azure</td>
                  <td className="py-3 pr-4">Alojamiento del servidor backend y base de datos</td>
                  <td className="py-3 pr-4">UE (Europa Occidental)</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-3 pr-4">Netlify, Inc.</td>
                  <td className="py-3 pr-4">Alojamiento del sitio web (frontend)</td>
                  <td className="py-3 pr-4">EE.UU. / UE CDN</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-3 pr-4">Stripe, Inc.</td>
                  <td className="py-3 pr-4">Procesamiento de pagos y suscripciones</td>
                  <td className="py-3 pr-4">EE.UU.</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-3 pr-4">OpenAI, LLC</td>
                  <td className="py-3 pr-4">Generación de detalles de recetas e ingredientes</td>
                  <td className="py-3 pr-4">EE.UU.</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-3 pr-4">Anthropic, PBC</td>
                  <td className="py-3 pr-4">Generación de planes de comidas y recetas alternativas</td>
                  <td className="py-3 pr-4">EE.UU.</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-3 pr-4">Google LLC (Gemini)</td>
                  <td className="py-3 pr-4">Generación de listas de la compra</td>
                  <td className="py-3 pr-4">EE.UU.</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-3 pr-4">Runware / ModelsLab</td>
                  <td className="py-3 pr-4">Generación de imágenes de recetas</td>
                  <td className="py-3 pr-4">EE.UU. / UE</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-3 pr-4">Typesense</td>
                  <td className="py-3 pr-4">Búsqueda y coincidencia de productos de supermercado</td>
                  <td className="py-3 pr-4">UE</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-3 pr-4">Amplitude, Inc.</td>
                  <td className="py-3 pr-4">Analítica de uso y grabación de sesiones</td>
                  <td className="py-3 pr-4">UE (servidor EU)</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-3 pr-4">Google LLC (Analytics)</td>
                  <td className="py-3 pr-4">Analítica web</td>
                  <td className="py-3 pr-4">EE.UU.</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-3 pr-4">ipwho.is</td>
                  <td className="py-3 pr-4">Detección de país por IP (sin almacenamiento permanente)</td>
                  <td className="py-3 pr-4">UE</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* ── 10. Transferencias internacionales ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">10. Transferencias Internacionales de Datos</h2>
          <p className="text-[16px] leading-[28px] mb-4">
            Algunos de nuestros proveedores de servicios están ubicados en Estados Unidos. Tus datos pueden transferirse fuera del Espacio Económico Europeo (EEE) bajo las siguientes garantías:
          </p>
          <ul className="list-disc pl-6 mb-6 space-y-3">
            <li className="text-[16px] leading-[28px]">
              <strong>Marco de Privacidad de Datos UE-EE.UU. (EU-US Data Privacy Framework):</strong> Stripe, Google y otros proveedores certificados bajo el DPF ofrecen un nivel de protección adecuado conforme a la decisión de adecuación de la Comisión Europea.
            </li>
            <li className="text-[16px] leading-[28px]">
              <strong>Cláusulas contractuales tipo (SCCs):</strong> Para proveedores no cubiertos por el DPF, utilizamos las cláusulas contractuales tipo aprobadas por la Comisión Europea (Decisión 2021/914) como mecanismo de transferencia.
            </li>
          </ul>
          <p className="text-[16px] leading-[28px] mb-6">
            Puedes solicitar información adicional sobre las garantías específicas aplicables a cada transferencia contactándonos en <a href="mailto:privacy@9meals.ai" className="text-[#006600] underline">privacy@9meals.ai</a>.
          </p>

          {/* ── 11. Divulgación ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">11. Divulgación de tu Información</h2>
          <p className="text-[16px] leading-[28px] mb-4">
            Además de los proveedores indicados en la sección 9, podemos compartir tu información en las siguientes circunstancias:
          </p>
          <ul className="list-disc pl-6 mb-6 space-y-3">
            <li className="text-[16px] leading-[28px]">
              <strong>Obligación legal.</strong> Si es razonablemente necesario para cumplir con una ley, regulación, proceso judicial o solicitud gubernamental.
            </li>
            <li className="text-[16px] leading-[28px]">
              <strong>Protección de derechos.</strong> Para proteger la seguridad personal de los usuarios o del público, o para proteger los derechos y la propiedad de Good UX OÜ.
            </li>
            <li className="text-[16px] leading-[28px]">
              <strong>Datos agregados o anonimizados.</strong> Podemos compartir información agregada o desidentificada que no pueda vincularse razonablemente a una persona física, con fines de investigación o mejora del servicio.
            </li>
          </ul>

          {/* ── 12. Retención ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">12. Retención y Eliminación de Datos</h2>
          <p className="text-[16px] leading-[28px] mb-4">
            Conservamos tus datos personales durante los siguientes períodos:
          </p>
          <div className="overflow-x-auto mb-6">
            <table className="w-full text-[14px] leading-[24px] border-collapse">
              <thead>
                <tr className="border-b border-gray-200">
                  <th className="text-left py-3 pr-4 font-bold">Categoría de datos</th>
                  <th className="text-left py-3 pr-4 font-bold">Período de conservación</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-100">
                  <td className="py-3 pr-4">Datos de cuenta (email, nombre)</td>
                  <td className="py-3 pr-4">Mientras mantengas tu cuenta activa, y hasta 30 días después de la solicitud de eliminación</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-3 pr-4">Preferencias y planes de comidas</td>
                  <td className="py-3 pr-4">Mientras mantengas tu cuenta activa</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-3 pr-4">Datos de pago (Stripe Customer ID)</td>
                  <td className="py-3 pr-4">5 años desde la última transacción (obligación fiscal)</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-3 pr-4">Datos de analítica</td>
                  <td className="py-3 pr-4">26 meses (conforme a la política de retención de Amplitude)</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-3 pr-4">Registros del servidor (logs)</td>
                  <td className="py-3 pr-4">90 días</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-3 pr-4">Datos locales del navegador (localStorage)</td>
                  <td className="py-3 pr-4">Hasta que los elimines manualmente o cierres sesión</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="text-[16px] leading-[28px] mb-6">
            Puedes eliminar tu cuenta directamente desde la configuración de la aplicación, o contactándonos en <a href="mailto:privacy@9meals.ai" className="text-[#006600] underline">privacy@9meals.ai</a>. Tras la solicitud de eliminación, eliminaremos tus datos personales de nuestros sistemas de forma permanente e irreversible dentro del plazo indicado, salvo que la ley nos obligue a conservarlos durante un período superior.
          </p>

          {/* ── 13. Seguridad ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">13. Seguridad de los Datos</h2>
          <p className="text-[16px] leading-[28px] mb-6">
            Implementamos medidas técnicas y organizativas adecuadas para proteger tus datos personales, incluyendo cifrado en tránsito (HTTPS/TLS), almacenamiento seguro de credenciales, control de acceso basado en roles y revisiones periódicas de seguridad. No obstante, ningún sistema es completamente seguro. En caso de brecha de seguridad que afecte a tus datos personales, te notificaremos sin dilación indebida y, en cualquier caso, dentro de las 72 horas siguientes conforme al artículo 33 del RGPD, e informaremos a la autoridad de control competente.
          </p>

          {/* ── 14. Menores ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">14. Privacidad de los Menores</h2>
          <p className="text-[16px] leading-[28px] mb-6">
            9meals.ai no está destinado a menores de 16 años, de acuerdo con el artículo 7 de la LOPDGDD. No recopilamos conscientemente datos personales de menores de dicha edad. Si tienes conocimiento de que un menor ha proporcionado datos personales sin el consentimiento de su representante legal, contáctanos en <a href="mailto:privacy@9meals.ai" className="text-[#006600] underline">privacy@9meals.ai</a> y procederemos a eliminar dicha información.
          </p>

          {/* ── 15. Derechos RGPD ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">15. Tus Derechos (RGPD y LOPDGDD)</h2>
          <p className="text-[16px] leading-[28px] mb-4">
            Como usuario en el Espacio Económico Europeo, tienes los siguientes derechos:
          </p>
          <ul className="list-disc pl-6 mb-6 space-y-3">
            <li className="text-[16px] leading-[28px]"><strong>Acceso</strong> — Solicitar una copia de los datos personales que conservamos sobre ti.</li>
            <li className="text-[16px] leading-[28px]"><strong>Rectificación</strong> — Corregir datos personales inexactos o incompletos.</li>
            <li className="text-[16px] leading-[28px]"><strong>Supresión</strong> — Solicitar la eliminación de tus datos personales («derecho al olvido»).</li>
            <li className="text-[16px] leading-[28px]"><strong>Limitación del tratamiento</strong> — Solicitar la restricción temporal del tratamiento de tus datos.</li>
            <li className="text-[16px] leading-[28px]"><strong>Portabilidad</strong> — Recibir tus datos en un formato estructurado, legible por máquina y de uso común.</li>
            <li className="text-[16px] leading-[28px]"><strong>Oposición</strong> — Oponerte al tratamiento de tus datos basado en interés legítimo, incluyendo la analítica.</li>
            <li className="text-[16px] leading-[28px]"><strong>Retirada del consentimiento</strong> — Retirar en cualquier momento el consentimiento prestado, sin que ello afecte a la licitud del tratamiento anterior.</li>
          </ul>
          <p className="text-[16px] leading-[28px] mb-4">
            Para ejercer cualquiera de estos derechos, envíanos un correo electrónico a <a href="mailto:privacy@9meals.ai" className="text-[#006600] underline">privacy@9meals.ai</a>. Responderemos en un plazo máximo de 30 días. Podemos requerir prueba de tu identidad antes de atender la solicitud.
          </p>
          <p className="text-[16px] leading-[28px] mb-6">
            Si consideras que no hemos atendido adecuadamente tu solicitud, tienes derecho a presentar una reclamación ante:
          </p>
          <ul className="list-disc pl-6 mb-6 space-y-3">
            <li className="text-[16px] leading-[28px]">
              <strong>Andmekaitse Inspektsioon</strong> (Inspección de Protección de Datos de Estonia) — autoridad de control principal de Good UX OÜ. Más información en <a href="https://www.aki.ee" className="text-[#006600] underline" target="_blank" rel="noopener noreferrer">www.aki.ee</a>.
            </li>
            <li className="text-[16px] leading-[28px]">
              <strong>Agencia Española de Protección de Datos (AEPD)</strong> — si te encuentras en España. Más información en <a href="https://www.aepd.es" className="text-[#006600] underline" target="_blank" rel="noopener noreferrer">www.aepd.es</a>.
            </li>
            <li className="text-[16px] leading-[28px]">
              La autoridad de protección de datos de tu país de residencia dentro del EEE.
            </li>
          </ul>

          {/* ── 16. Fusión / venta ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">16. En Caso de Fusión, Venta o Quiebra</h2>
          <p className="text-[16px] leading-[28px] mb-6">
            En caso de que Good UX OÜ sea adquirido por o fusionado con otra entidad, nos reservamos el derecho de transferir la información que hemos recopilado como parte de dicha operación. Te notificaremos de cualquier cambio en el responsable del tratamiento de tus datos personales.
          </p>

          {/* ── 17. Cambios ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">17. Cambios a esta Política de Privacidad</h2>
          <p className="text-[16px] leading-[28px] mb-6">
            Podemos actualizar esta política periódicamente. La fecha de «Última actualización» al inicio del documento refleja la versión vigente. Si realizamos cambios sustanciales, te notificaremos mediante un aviso visible en la aplicación o por correo electrónico antes de que los cambios entren en vigor. El uso continuado de 9meals.ai tras la notificación implica la aceptación de la política revisada.
          </p>

          {/* ── 18. Contacto ── */}
          <h2 className="text-[20px] font-bold mt-8 mb-4">18. Contáctanos</h2>
          <p className="text-[16px] leading-[28px] mb-2">
            Si tienes alguna pregunta sobre esta Política de Privacidad o sobre el tratamiento de tus datos personales:
          </p>
          <ul className="list-none pl-0 mb-6 space-y-1">
            <li className="text-[16px] leading-[28px]"><strong>Correo electrónico:</strong> <a href="mailto:privacy@9meals.ai" className="text-[#006600] underline">privacy@9meals.ai</a></li>
            <li className="text-[16px] leading-[28px]"><strong>Responsable:</strong> Good UX OÜ, Registro Mercantil de Estonia nº 16529659</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
